import classNames from "classnames";
import { useMemo } from "react";
import AscModuleCard from "../AscCards/AscModuleCard/AscModuleCard";
import AscLink from "../AscLink/AscLink";
import {
  AscModulesListModule,
  AscModulesListProps,
} from "./AscModuleList.types";
import styles from "./AscModulesList.module.scss";
import { ignoreAttribute } from "@ascendnow/shared";

const LOADING_MODULES = new Array(7).fill({} as AscModulesListModule);

export default function AscModulesList({
  modules = LOADING_MODULES,
  className,
  fullWidth = false,
  loading = false,
  type,
  color = "TEAL",
}: AscModulesListProps) {
  const lastUncompletedIndex = useMemo(
    () => modules?.findIndex((m) => !m?.completed),
    [modules]
  );
  const percentComplete = useMemo(() => {
    const total = modules?.length || 1;
    return (
      ((lastUncompletedIndex + ((lastUncompletedIndex / total) % 1) * 1) /
        total) *
      100
    );
  }, [modules, lastUncompletedIndex]);

  const modulesList = useMemo(
    () =>
      modules?.map((module, index) => (
        <AscModule
          key={module?.id || index}
          module={module}
          loading={loading}
          disabled={false}
        />
      )),
    [lastUncompletedIndex, loading, modules, type]
  );
  return (
    <div
      className={classNames(
        styles.ground,
        {
          [styles.fullWidth]: fullWidth,

          //colors
          [styles.teal]: color === "TEAL",
          [styles.pink]: color === "PINK",
          [styles.green]: color === "GREEN",
          [styles.orange]: color === "ORANGE",
          [styles.purple]: color === "PURPLE",
        },
        className
      )}
      {...ignoreAttribute.contrast}
    >
      <div className={styles.modulesContainer} {...ignoreAttribute.contrast}>
        {modulesList}
      </div>
      <div
        style={{ height: `${percentComplete}%` }}
        className={styles.progressBar}
        {...ignoreAttribute.contrast}
      />
    </div>
  );
}

interface AscProgressStepProps {
  module: AscModulesListModule;
  loading: boolean;
  disabled?: boolean;
}
function AscModule({
  module,
  loading,
  disabled = false,
}: AscProgressStepProps) {
  return (
    <div
      className={classNames(styles.module, {
        [styles.completed]: module?.completed,
      })}
      {...ignoreAttribute.contrast}
    >
      <div className={styles.markerContainer} {...ignoreAttribute.contrast}>
        <div className={styles.marker} {...ignoreAttribute.contrast} />
      </div>
      <AscLink
        className={styles.moduleCardLink}
        href={module?.url}
        disabled={disabled}
        innerWrapperTag={null}
      >
        <AscModuleCard
          loading={loading}
          className={styles.moduleCard}
          title={module?.title}
          lengthInMinutes={module?.lengthInMinutes}
          completed={module?.completed}
        />
      </AscLink>
    </div>
  );
}
